import { RouteConfig } from 'vue-router'
import VueI18n from 'vue-i18n'

const StripePaymentView: DynamicImport = () => import(/* webpackChunkName: "public" */ '../views/StripePaymentView/StripePaymentView.vue')
const PaymentSuccessfulView: DynamicImport = () => import(/* webpackChunkName: "public" */ '../views/PaymentSuccessfulView.vue')
const PublicSignatureView: DynamicImport = () => import(/* webpackChunkName: "public" */ '../views/PublicSignatureView/PublicSignatureView.vue')

import InvoiceMultipleDocuments from '../components/InvoiceMultipleDocuments/InvoiceMultipleDocuments.vue'
const QuotationList: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/QuotationListView.vue')
const AffairList: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/AffairListView.vue')
const CommandList: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/CommandListView.vue')
const ProformaList: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/ProformaListView.vue')
const DeliveryList: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/DeliveryListView.vue')
const DocumentForm: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/DocumentFormView.vue')
const DocumentItem: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/DocumentItemView.vue')
const InvoiceList: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/InvoiceListView.vue')
const DepositInvoiceList: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/DepositInvoiceListView.vue')
const CreditList: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/CreditListView.vue')
const PaymentList: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/PaymentListView.vue')
const GuaranteeHoldback: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/GuaranteeHoldbackView.vue')
const DownloadPdfExport: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/DownloadPdfExportView.vue')
const RecoveryInvoicesView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/RecoveryInvoicesView.vue')
const CustomerSepaListView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/CustomerSepaListView.vue')
const ContractListView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/ContractListView.vue')
const ContractFormView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/ContractFormView.vue')
const ContractItemView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/ContractItemView.vue')
const ContractDeadlineListView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/ContractDeadlineListView.vue')
const SepaDepositListView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/SepaDepositListView.vue')
const SepaDepositFormView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/SepaDepositFormView.vue')
const SepaDepositItemView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/SepaDepositItemView.vue')
const InvoiceToPaidList: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/InvoiceToPaidView.vue')
const CheckDepositListView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/CheckDepositListView.vue')
const CheckDepositFormView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/CheckDepositFormView.vue')
const CheckDepositItemView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/CheckDepositItemView.vue')
const PaymentVatRatesView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/PaymentVatRatesView.vue')
const SalesVatRatesView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/SalesVatRatesView.vue')
const CommissionDocumentView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/CommissionDocumentView.vue')
const CommissionPaymentView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/CommissionPaymentView.vue')
const CarListView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/CarListView.vue')
const AccountTransactionView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/AccountTransactionView.vue')

const routes: (i18n: VueI18n) => RouteConfig[] = () => ([
  {
    path: '/sales/affairs',
    name: 'affair-list',
    component: AffairList,
    meta: {
      title: 'Liste des affaires'
    }
  },
  {
    path: '/sales/quotations',
    name: 'quotation-list',
    component: QuotationList,
    meta: {
      title: 'Liste des devis',
      userPermission: ['sales-quotation', 1],
      buttons: [
        {
          label: 'Nouveau devis',
          to: '/sales/quotations/form',
          userPermission: ['sales-quotation', 2]
        },
        {
          component: InvoiceMultipleDocuments,
          attributes: {
            label: 'Facturer plusieurs devis',
            type: 'quotation',
            userPermission: ['sales-invoice', 2]
          }
        }
      ]
    }
  },
  {
    path: '/sales/quotations/form/:id?',
    name: 'quotation-form',
    component: DocumentForm,
    meta: {
      sidebarMode: 2,
      allowFullscreen: true,
      pageHeader: false,
      documentType: 'quotation',
      userPermission: ['sales-quotation', 2]
    }
  },
  {
    path: '/sales/quotations/:id',
    name: 'quotation-item',
    component: DocumentItem,
    meta: {
      pageHeader: false,
      documentType: 'quotation',
      userPermission: ['sales-quotation', 1],
      appClass: { 'sales-page-item': true }
    }
  },
  {
    path: '/sales/commands',
    name: 'command-list',
    component: CommandList,
    meta: {
      title: 'Liste des bons de commande',
      appModule: 'sales-commands',
      userPermission: ['sales-command', 1],
      buttons: [
        {
          label: 'Nouveau bon de commande',
          to: '/sales/commands/form',
          userPermission: ['sales-command', 2]
        },
        {
          component: InvoiceMultipleDocuments,
          attributes: {
            label: 'Facturer plusieurs bons de commande',
            type: 'command',
            userPermission: ['sales-invoice', 2],
          }
        }
      ]
    }
  },
  {
    path: '/sales/commands/form/:id?',
    name: 'command-form',
    component: DocumentForm,
    meta: {
      appModule: 'sales-commands',
      userPermission: ['sales-command', 2],
      sidebarMode: 2,
      allowFullscreen: true,
      pageHeader: false,
      documentType: 'command'
    }
  },
  {
    path: '/sales/commands/:id',
    name: 'command-item',
    component: DocumentItem,
    meta: {
      appModule: 'sales-commands',
      userPermission: ['sales-command', 1],
      pageHeader: false,
      documentType: 'command',
      appClass: { 'sales-page-item': true }
    }
  },
  {
    path: '/sales/proformas',
    name: 'proforma-list',
    component: ProformaList,
    meta: {
      title: 'Liste des factures proforma',
      appModule: 'sales-proformas',
      userPermission: ['sales-proforma', 1],
      buttons: [
        {
          label: 'Nouvelle facture proforma',
          to: '/sales/proformas/form',
          userPermission: ['sales-proforma', 2]
        },
        {
          component: InvoiceMultipleDocuments,
          attributes: {
            label: 'Facturer plusieurs factures proforma',
            type: 'proforma',
            userPermission: ['sales-invoice', 2]
          }
        }
      ]
    }
  },
  {
    path: '/sales/proformas/form/:id?',
    name: 'proforma-form',
    component: DocumentForm,
    meta: {
      appModule: 'sales-proformas',
      userPermission: ['sales-proforma', 2],
      sidebarMode: 2,
      allowFullscreen: true,
      pageHeader: false,
      documentType: 'proforma'
    }
  },
  {
    path: '/sales/proformas/:id',
    name: 'proforma-item',
    component: DocumentItem,
    meta: {
      appModule: 'sales-proformas',
      userPermission: ['sales-proforma', 1],
      pageHeader: false,
      documentType: 'proforma',
      appClass: { 'sales-page-item': true }
    }
  },
  {
    path: '/sales/deliveries',
    name: 'delivery-list',
    component: DeliveryList,
    meta: {
      title: 'Liste des bons de livraison',
      appModule: 'sales-deliveries',
      userPermission: ['sales-delivery', 1],
      buttons: [
        {
          label: 'Nouveau bon de livraison',
          to: '/sales/deliveries/form',
          userPermission: ['sales-delivery', 2]
        },
        {
          component: InvoiceMultipleDocuments,
          attributes: {
            label: 'Facturer plusieurs bons de livraison',
            type: 'delivery',
            userPermission: ['sales-invoice', 2]
          }
        }
      ]
    }
  },
  {
    path: '/sales/deliveries/form/:id?',
    name: 'delivery-form',
    component: DocumentForm,
    meta: {
      appModule: 'sales-deliveries',
      userPermission: ['sales-delivery', 2],
      sidebarMode: 2,
      allowFullscreen: true,
      pageHeader: false,
      documentType: 'delivery'
    }
  },
  {
    path: '/sales/deliveries/:id',
    name: 'delivery-item',
    component: DocumentItem,
    meta: {
      appModule: 'sales-deliveries',
      userPermission: ['sales-delivery', 1],
      pageHeader: false,
      documentType: 'delivery',
      appClass: { 'sales-page-item': true }
    }
  },
  {
    path: '/invoicing/invoices',
    name: 'invoice-list',
    component: InvoiceList,
    meta: {
      title: 'Liste des factures',
      userPermission: ['sales-invoice', 1],
      buttons: [
        {
          label: 'Nouvelle facture',
          to: '/invoicing/invoices/form',
          userPermission: ['sales-invoice', 2]
        }
      ]
    }
  },
  {
    path: '/invoicing/to-paid-invoices',
    name: 'invoice-to-paid-list',
    component: InvoiceToPaidList,
    meta: {
      title: 'Factures en attente de paiement',
      userPermission: ['sales-invoice', 1]
    }
  },
  {
    path: '/invoicing/deposit-invoices',
    name: 'deposit-invoice-list',
    component: DepositInvoiceList,
    meta: {
      title: 'Liste des factures d\'acompte',
      userPermission: ['sales-invoice', 1]
    }
  },
  {
    path: '/invoicing/invoices/form/:id?',
    name: 'invoice-form',
    component: DocumentForm,
    meta: {
      sidebarMode: 2,
      allowFullscreen: true,
      pageHeader: false,
      documentType: 'invoice',
      userPermission: ['sales-invoice', 2]
    }
  },
  {
    path: '/invoicing/invoices/:id',
    name: 'invoice-item',
    component: DocumentItem,
    meta: {
      pageHeader: false,
      documentType: 'invoice',
      userPermission: ['sales-invoice', 1],
      appClass: { 'sales-page-item': true }
    }
  },
  {
    path: '/invoicing/credits',
    name: 'credit-list',
    component: CreditList,
    meta: {
      title: 'Liste des avoirs',
      userPermission: ['sales-credit', 1],
      buttons: [
        {
          label: 'Nouvel avoir',
          to: '/invoicing/credits/form',
          userPermission: ['sales-credit', 2]
        }
      ]
    }
  },
  {
    path: '/invoicing/credits/form/:id?',
    name: 'credit-form',
    component: DocumentForm,
    meta: {
      sidebarMode: 2,
      allowFullscreen: true,
      pageHeader: false,
      documentType: 'credit',
      userPermission: ['sales-credit', 2]
    }
  },
  {
    path: '/invoicing/credits/:id',
    name: 'credit-item',
    component: DocumentItem,
    meta: {
      pageHeader: false,
      documentType: 'credit',
      userPermission: ['sales-credit', 1],
      appClass: { 'sales-page-item': true }
    }
  },
  {
    path: '/invoicing/vatrates',
    name: 'sales-vatrates-dashboard',
    component: SalesVatRatesView,
    meta: {
      title: 'Récapitulatif de la TVA',
      userPermission: ['sales-invoice', 1]
    }
  },
  {
    path: '/payments/payments',
    name: 'payment-list',
    component: PaymentList,
    meta: {
      title: 'Liste des encaissements',
      userPermission: ['sales-invoice', 1]
    }
  },
  {
    path: '/payments/vatrates',
    name: 'payments-vatrates-dashboard',
    component: PaymentVatRatesView,
    meta: {
      title: 'Récapitulatif de la TVA',
      userPermission: ['sales-invoice', 1]
    }
  },
  {
    path: '/invoicing/guarantee-holdback',
    name: 'guarantee-holdback-list',
    component: GuaranteeHoldback,
    meta: {
      title: 'Liste des retenues de garantie',
      userPermission: ['sales-invoice', 1],
      appModule: 'sales-guarantee-holdback'
    }
  },
  {
    path: '/pdf-exports/:id/download',
    name: 'pdf-export-download',
    component: DownloadPdfExport,
    meta: {
      pageHeader: false,
      title: 'Téléchargement'
    }
  },
  {
    path: '/invoicing/recovery',
    name: 'invoicing-recovery',
    component: RecoveryInvoicesView,
    meta: {
      title: 'Relance des factures impayées',
      appModule: 'sales-recovery',
      buttons: [
        {
          label: 'Configuration',
          variant: 'secondary',
          to: { name: 'sales-recovery-invoice-steps' }
        }
      ]
    }
  },
  {
    path: '/payments/sepa',
    name: 'sepa-list',
    component: CustomerSepaListView,
    meta: {
      title: 'Liste des mandats SEPA',
      appModule: 'sales-sepa',
      userPermission: ['sales-invoice', 1],
      pageHeader: false
    }
  },
  {
    path: '/payments/deposit-sepa',
    name: 'sepa-deposit-list',
    component: SepaDepositListView,
    meta: {
      title: 'Liste des remises de prélèvement SEPA',
      appModule: 'sales-sepa',
      userPermission: ['sales-invoice', 1],
      buttons: [
        {
          label: 'Créer une remise',
          variant: 'primary',
          to: { name: 'sepa-deposit-form' }
        }
      ]
    }
  },
  {
    path: '/payments/deposit-sepa/form/:id?',
    name: 'sepa-deposit-form',
    component: SepaDepositFormView,
    meta: {
      title: 'Remise de prélèvement SEPA',
      appModule: 'sales-sepa',
      userPermission: ['sales-invoice', 3],
      pageHeader: false
    }
  },
  {
    path: '/payments/deposit-sepa/:id',
    name: 'sepa-deposit-item',
    component: SepaDepositItemView,
    meta: {
      title: 'Remise de prélèvement SEPA',
      appModule: 'sales-sepa',
      userPermission: ['sales-invoice', 1],
      pageHeader: false
    }
  },

  {
    path: '/public/sign/:id/:yousignId/:hash',
    name: 'public-sign',
    component: PublicSignatureView,
    meta: {
      isPublic: true,
      noTemplate: true
    }
  },
  {
    path: '/public/sign/test/:id/:yousignId/:hash',
    name: 'public-sign-test',
    component: PublicSignatureView,
    meta: {
      isPublic: true,
      noTemplate: true
    }
  },
  {
    path: '/public/:type/:id/:token/:hash',
    name: 'public-stripe-payment',
    component: StripePaymentView,
    meta: {
      isPublic: true,
      noTemplate: true
    }
  },
  {
    path: '/public/payment/:accountId/checkout',
    name: 'public-stripe-checkout',
    component: PaymentSuccessfulView,
    meta: {
      isPublic: true,
      noTemplate: true
    }
  },

  {
    path: '/contracts/contracts',
    name: 'contract-list',
    component: ContractListView,
    meta: {
      pageHeader: false,
      title: 'Liste des contracts',
      appModule: 'sales-contracts',
      userPermission: ['sales-contracts', 1],
      buttons: [
        {
          label: 'Créer un contrat',
          variant: 'primary',
          to: { name: 'contract-form' }
        }
      ]
    }
  },
  {
    path: '/contracts/contracts/form/:id?',
    name: 'contract-form',
    component: ContractFormView,
    meta: {
      pageHeader: false,
      sidebarMode: 2,
      allowFullscreen: true,
      title: 'Modification d\'un contrat',
      appModule: 'sales-contracts',
      userPermission: ['sales-contracts', 2]
    }
  },
  {
    path: '/contracts/contracts/:id',
    name: 'contract-item',
    component: ContractItemView,
    meta: {
      pageHeader: false,
      title: 'Fiche contrat',
      appModule: 'sales-contracts',
      userPermission: ['sales-contracts', 1]
    }
  },
  {
    path: '/contracts/deadlines',
    name: 'contract-deadline-list',
    component: ContractDeadlineListView,
    meta: {
      title: 'Liste des échéances',
      appModule: 'sales-contracts',
      userPermission: ['sales-contracts', 1]
    }
  },

  {
    path: '/payments/check-deposit',
    name: 'check-deposit-list',
    component: CheckDepositListView,
    meta: {
      title: 'Liste des remises de chèques',
      appModule: 'sales-checks-deposits',
      userPermission: ['sales-invoice', 1],
      buttons: [
        {
          label: 'Créer une remise',
          variant: 'primary',
          to: { name: 'check-deposit-form' }
        }
      ]
    }
  },
  {
    path: '/payments/check-deposit/form/:id?',
    name: 'check-deposit-form',
    component: CheckDepositFormView,
    meta: {
      title: 'Remise de chèque',
      appModule: 'sales-checks-deposits',
      userPermission: ['sales-invoice', 3],
      pageHeader: false
    }
  },
  {
    path: '/payments/check-deposit/:id',
    name: 'check-deposit-item',
    component: CheckDepositItemView,
    meta: {
      title: 'Remise de chèque',
      appModule: 'sales-checks-deposits',
      userPermission: ['sales-invoice', 1],
      pageHeader: false
    }
  },
  {
    path: '/commissions/commissions',
    name: 'commissions-list',
    component: CommissionDocumentView,
    meta: {
      title: 'Liste des commissions',
      pageHeader: false,
      appModule: 'sales-commissions',
      userPermission: ['sales-commissions', 1]
    }
  },
  {
    path: '/commissions/payments',
    name: 'commissions-payments-list',
    component: CommissionPaymentView,
    meta: {
      title: 'Paiements des commissions',
      pageHeader: false,
      appModule: 'sales-commissions',
      userPermission: ['sales-commissions', 1]
    }
  },
  {
    path: '/cars',
    name: 'cars-list',
    component: CarListView,
    meta: {
      title: 'Liste des véhicules',
      pageHeader: false,
      appModule: 'automotive'
    }
  },
  {
    path: '/accounts',
    name: 'accounts',
    component: AccountTransactionView,
    meta: {
      title: 'Comptes bancaires',
      pageHeader: false,
      userPermission: ['sales-accounts', 1]
    }
  }
])

export default routes
